/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Showinsplit2Inputs */

const en_entity_showinsplit2 = /** @type {(inputs: Entity_Showinsplit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show In Split`)
};

const de_entity_showinsplit2 = /** @type {(inputs: Entity_Showinsplit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Split anzeigen`)
};

/**
* | output |
* | --- |
* | "Show In Split" |
*
* @param {Entity_Showinsplit2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_showinsplit2 = /** @type {((inputs?: Entity_Showinsplit2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Showinsplit2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_showinsplit2(inputs)
	return de_entity_showinsplit2(inputs)
});
export { entity_showinsplit2 as "entity_showInSplit" }